
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  size?: "default" | "medium" | "large";
}

const CTAButton = ({ children, className, onClick, size = "default" }: CTAButtonProps) => {
  const sizeClasses = 
    size === "large" ? "px-14 py-12 text-3xl min-w-[300px]" : 
    size === "medium" ? "px-10 py-8 text-2xl min-w-[240px]" :
    "px-8 py-6 text-xl min-w-[200px]";
    
  return (
    <Button
      className={cn(
        `cta-1 bg-[rgb(86,104,241)] hover:bg-[rgb(86,104,241)]/90 text-white ${sizeClasses} rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg h-auto`,
        className
      )}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default CTAButton;
